import googleAnalyticsClient from '../common/google_analytics/staff_tracking';

window.addEventListener('load', () => {
  // ページ読み込み時に実行する
  const el = document.querySelector<HTMLElement>('#staff_infomation');
  const staffId = el?.dataset.staffId;
  const currentPath = el?.dataset.currentPath;
  const now = el?.dataset.now;

  if(staffId && currentPath && now) {
    googleAnalyticsClient.pageView({
      time: now,
      path: currentPath,
      staffId: staffId,
    });
  }
});
